import rawDisciplines from '@/../static/data/disciplines.json';
import rawPersonalityTypes from '@/../static/data/personalityTypes.json';
import rawDisciplineMatches from '@/../static/data/disciplineMatches.json';

import { IQuestion, INumberBasedQuestion } from '@/interfaces/questions.interface';
import { IDiscipline, IDisciplineMatches, IPersonalityType, IResult } from '@/interfaces/state.interface';

export class PersonalityTestResults {

	// Trigger the scores per personality type to be calculated and prepare the properties that make up the results.
	static getResults(scores: IQuestion[]): IResult {
		let types = PersonalityTestResults.getPersonalityScores(scores);

		const personalityTypes = types = PersonalityTestResults.sortPersonalityTypes(types);
		const threeLetterCode = PersonalityTestResults.getThreeLetterCode(types);
		const disciplines = PersonalityTestResults.getDisciplines(threeLetterCode);

		return {
			personalityTypes,
			threeLetterCode,
			disciplines
		};
	}

	// Get the personality types, each with a score based on the answers of the user.
	static getPersonalityScores(questions: IQuestion[]): IPersonalityType[] {
		const types = rawPersonalityTypes.config as IPersonalityType[];
		const numberBasedQuestions = questions.filter(
			question => typeof question.answer === 'number'
		) as INumberBasedQuestion[];

		for (let i = 0; i < types.length; i++) {
			types[i].score = numberBasedQuestions
				.filter(question => question.type === i + 1)
				.reduce((acc, question) => acc + question.answer * 2, 0);
		}

		return types;
	}

	// Sort the list of personality types based on the score values inside.
	static sortPersonalityTypes(types: IPersonalityType[]): IPersonalityType[] {
		return types.sort((a, b) => (a.score > b.score) ? -1 : 1);
	}

	// Get the three letter code, which contains the 1st letter of each personality type that came out as the best match for the user.
	static getThreeLetterCode(types: IPersonalityType[]): string {
		return types.slice(0, 3)
			.map(x => x.trait.charAt(0))
			.join("")
			.toUpperCase();
	}

	// Based on the matching personality types and three letter code, retrieve the 4 disciplines that should be suggested to the user.
	static getDisciplines(code: string): IDiscipline[] {
		const firstLetter = code.charAt(0);
		const types = rawDisciplineMatches.types as IDisciplineMatches;
		const disciplines = rawDisciplines.config as IDiscipline[];
		const disciplineIds = types[firstLetter][code];

		return disciplines.filter(discipline => disciplineIds.includes(discipline.id));
	}
}
